import { Color } from '../../mol-util/color';
import { Location } from '../../mol-model/location';
import { StructureElement, StructureProperties } from '../../mol-model/structure';
import { ColorTheme } from '../color';
import { ParamDefinition as PD } from '../../mol-util/param-definition';
import { ThemeDataContext } from '../../mol-theme/theme';

const ShakerHydrophobicityColors = {
    'ILE': Color(0xFF1010), 'PHE': Color(0xFF1C1C), 'VAL': Color(0xFD2828),
    'LEU': Color(0xFD3535), 'TRP': Color(0xFD4141), 'MET': Color(0xFC4D4D),
    'ALA': Color(0xFC5959), 'GLY': Color(0xFB6464), 'CYS': Color(0xFB7171),
    'TYR': Color(0xFB7D7D), 'PRO': Color(0xFA8989), 'THR': Color(0xFA9595),
    'SER': Color(0xFAA2A2), 'HIS': Color(0xF9AEAE), 'GLU': Color(0xF9BABA),
    'ASN': Color(0xF8C6C6), 'GLN': Color(0xF8D2D2), 'ASP': Color(0xF8DFDF),
    'LYS': Color(0xE5EBEB), 'ARG': Color(0xE5F7F7)
};
const DefaultColor = Color(0xCCCCCC);

export function ShakerHydrophobicityColorTheme(ctx: ThemeDataContext, props: {}): ColorTheme<{}> {
    let color: (location: Location) => Color;

    if (ctx.structure) {
        color = (location: Location) => {
            if (StructureElement.Location.is(location)) {
                const compId = StructureProperties.residue.label_comp_id(location);
                return (ShakerHydrophobicityColors as any)[compId] || DefaultColor;
            }
            return DefaultColor;
        };
    } else {
        color = () => DefaultColor;
    }

    return {
        factory: ShakerHydrophobicityColorTheme,
        granularity: 'group',
        color,
        props,
        description: 'Escala personalizada de Hidrofobicidad para Shaker UMH.'
    };
}

export const ShakerHydrophobicityColorThemeProvider: ColorTheme.Provider<{}, 'shaker-hydrophobicity'> = {
    name: 'shaker-hydrophobicity',
    label: 'Shaker Hidrofobicidad',
    // CORREGIDO: Usamos la cadena directa para evitar el problema de carga de ColorTheme
    category: 'Residue' as any, 
    factory: ShakerHydrophobicityColorTheme,
    getParams: () => ({}),
    defaultValues: PD.getDefaultValues({}),
    isApplicable: (ctx: ThemeDataContext) => !!ctx.structure
};